import React from 'react';

import { StyledSelect } from './Select-styled-components';

interface Option {
  id: string;
  name: string;
}

interface SelectProps {
  options: Option[];
  required?: boolean;
  onSelect: (optionValue: Option['id']) => void;
  value: Option['id'] | null;
  placeholderText?: string;
  isInvalid?: boolean;
  isSensitive?: boolean;
}

export const Select = ({
  options = [],
  required,
  onSelect,
  value,
  placeholderText,
  isInvalid,
  isSensitive = true,
}: SelectProps) => {
  const sensitiveClassName = isSensitive ? 'sensitive-data' : '';

  return (
    <StyledSelect
      className={sensitiveClassName}
      required={required}
      onSelect={onSelect}
      value={value || null}
      placeholder={placeholderText}
      $isInvalid={isInvalid}
    >
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </StyledSelect>
  );
};
